import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'
import './BtnHelp.sass'

{/* eslint-disable */}
const BtnHelp = ({handleClickOverflow}) => <a className="btn-question" title="Есть вопрос?" onClick={handleClickOverflow}><Icon type='help' /></a>

BtnHelp.propTypes = {
  handleClickOverflow: PropTypes.func.isRequired
}

export default BtnHelp



// WEBPACK FOOTER //
// ./components/BtnHelp/index.jsx